// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2K5Ty","containerItemsCenter":"Skeleton_containerItemsCenter__1Z33x"};